<template>
  <Head>
    <title>Add New Product | NutriStudents K-12</title>
    <meta name="description" content="Add New Product">
  </Head>
  <default-layout>

    <BreadcrumLayout>
      <div class="flex">
        <!-- <a href="#" class="link-color"> --><U>Templates</U><!-- </a> -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd" />
        </svg>
        <inertia-link :href="route('products')" class="link-color"><U>Products</U></inertia-link>
      </div>
    </BreadcrumLayout>


    <form action="#" @submit.prevent="false">

      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 md:w-4/6">
          <h1 class="heading-color  2xl:text-2xl text-xl font-bold">Add New Product</h1>
        </div>
        <span class="bg-red-800 text-white md:w-3/6 p-3 text-center" v-if="form.hasErrors">*Some Required Fields are
          Missing</span>
        <div class="w-full flex lg:flex-nowrap flex-wrap md:justify-end items-center">

          <button type="button">
            <inertia-link :href="route('products')"
              class="w-full inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase bg-gray-500 text-white  focus:outline-none sm:w-40">Cancel</inertia-link>
          </button>

          <button type="button" @click="product_add_save_script"
            class="menu1-background-color w-full inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase button-color text-white  focus:outline-none sm:ml-3 sm:w-40 mt-3 sm:mt-0">
            Save
          </button>





        </div>
      </PageTitleLayout>


      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 w-full md:mt-0 mt-6">
          <h1 class="text-base text-gray-500 font-bold" id="response_msg"></h1>
        </div>
      </PageTitleLayout>



      <PageTitleLayout>
        <div
          class="md:flex block justify-between shadow py-8 mt-4 align-middle inline-block min-w-full bg-white rounded-t-lg xl:divide-x-2 divide-gray-300 border-b-4 border-gray-300 w-full overflow-x-auto">
          <div class="w-6/12">

            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-12 md:pl-12 pl-6">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">Product Name*</label>
              <div>
                <input type="text" id="pname" name="pname" v-model="form.pname"
                  class="2xl:text-base text-base text-gray-400 xl:mt-0 mt-4 sm:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg select-menu-height input-background">
                <div v-if="form.errors.pname" class="validation_error_msg">{{ form.errors.pname }}</div>
              </div>
            </div>



            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-12 md:pl-12 pl-6 pt-10">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">Distributor</label>

              <div class="relative focus:outline-none sm:w-80 w-60 xl:pl-4 pl-0 xl:mt-0 mt-4">
                <select id="distributor_id_val" name="distributor_id_val" autocomplete="distributor_id_val"
                  v-model="form.distributor_id_val"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base text-gray-400">
                  <option value="">Distributor</option>
                  <option v-for="distributor in form.distributor_products" :value="distributor.distributor.id">{{ distributor.distributor.name }}</option>
                </select>
                <div
                  class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
              </div>
            </div>

            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-24 md:pl-12 pl-6 pt-10">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">GTIN Number</label>
              <input type="text" id="pgtin" name="pgtin" v-model="form.pgtin"
                class="2xl:text-base text-sm text-gray-400 xl:mt-0 mt-4 2xl:w-80 xl:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg select-menu-height input-background">

            </div>


          </div>


          <div class="sm:w-6/12  sm:mr-0 mr-4">
            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-24 md:pl-12 pl-6 md:pt-0 pt-10">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">Manufacturer*</label>
              <div>
                <input type="text" id="pmanufacturer" name="pmanufacturer" v-model="form.pmanufacturer"
                  class="2xl:text-base text-sm text-gray-400 xl:mt-0 mt-4 2xl:w-80 xl:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg select-menu-height input-background">
                <div v-if="form.errors.pmanufacturer" class="validation_error_msg">{{ form.errors.pmanufacturer }}</div>
              </div>
            </div>

            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-24 md:pl-12 pl-6 pt-10">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">Manufacturer #*</label>
              <div>
                <input type="text" id="pmanufacturer_sku" name="pmanufacturer_sku" v-model="form.pmanufacturer_sku"
                  class="2xl:text-base text-sm text-gray-400 xl:mt-0 mt-4 2xl:w-80 xl:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg select-menu-height input-background">
                <div v-if="form.errors.pmanufacturer_sku" class="validation_error_msg">{{ form.errors.pmanufacturer_sku
                }}</div>
              </div>
            </div>

            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-24 md:pl-12 pl-6 pt-10">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">CN #</label>
              <div>
                <input type="text" id="cn_code" name="cn_code" v-model="form.cn_code"
                  class="2xl:text-base text-sm text-gray-400 xl:mt-0 mt-4 2xl:w-80 xl:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg select-menu-height input-background"
                  @blur="getCNNutrations" v-on:keyup.enter="getCNNutrations">
                <div v-if="form.errors.cn_code" class="validation_error_msg">{{ form.errors.cn_code
                }}</div>
              </div>
            </div>

            <div class="xl:flex block  xl:items-center xl:justify-evenly xl:pl-0 lg:pl-24 md:pl-12 pl-6 pt-10">
              <label class="font-bold text-gray-700 2xl:text-lg text-base">USDA Foods Material <br> Code (FNS Material
                Number)</label>
              <div>
                <input type="text" id="wbscm_commodity_code" name="wbscm_commodity_code"
                  v-model="form.wbscm_commodity_code"
                  class="2xl:text-base text-sm text-gray-400 xl:mt-0 mt-4 2xl:w-80 xl:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg select-menu-height input-background">
                <div v-if="form.errors.wbscm_commodity_code" class="validation_error_msg">{{
                  form.errors.wbscm_commodity_code
                }}</div>
              </div>
            </div>


          </div>
        </div>

      </PageTitleLayout>

      <header
        class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg sm:mx-10 mx-6 mt-10">
        <h2 class="text-white text-lg font-bold w-11/12">Product Categories</h2>

      </header>

      <div class="flex flex-col mb-6 mx-10">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full">
                <thead class="header-bg-color">
                  <tr>
                    <th colspan="3" scope="col"
                      class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Primary*
                    </th>
                    <th colspan="4" scope="col"
                      class="px-20  py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      Secondary
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Oddd row -->
                  <tr class="bg-white align-top">
                    <td colspan="3" class="px-6 py-4 whitespace-nowrap text-base font-bold">
                      <div class="space-x-4">
                        <div class="relative focus:outline-none lg:w-52 w-40  inline-block align-top">
                          <select id="primary_cat_val" name="primary_cat_val" autocomplete="primary_cat_val"
                            v-model="form.primary_cat_val"
                            class="text-gray-400 text-base shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                            @change="onCategoryChangefunc">
                            <option value="">Category</option>
                            <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-show="form.errors.primary_cat_val" class="validation_error_msg">{{
                            form.errors.primary_cat_val }}</div>
                        </div>
                        <div class="relative focus:outline-none lg:w-52 w-40  inline-block align-top">
                          <select id="primary_subcat_val" name="primary_subcat_val" autocomplete="primary_subcat_val"
                            v-model="form.primary_subcat_val"
                            class="text-gray-400 text-base shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height">
                            <option value="">Sub Category</option>
                            <option v-for="subcat_val in subcat_vals" :value="subcat_val.id">{{ subcat_val.name }}
                            </option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-show="form.errors.primary_subcat_val" class="validation_error_msg">{{
                            form.errors.primary_subcat_val }}</div>
                        </div>
                      </div>
                    </td>
                    <td colspan="3" class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"></td>
                    <td colspan="3" class="px-6 py-4 whitespace-nowrap text-base font-bold">
                      <div class="flex items-center">
                        <div class="w-full space-y-2">
                          <div v-for="(cat_counter, index) in sec_cat_counters" class="space-x-4 w-full pr-2">
                            <div class="relative focus:outline-none lg:w-52 w-40  inline-block">
                              <select id="secondary_cat_val" name="secondary_cat_val" autocomplete="secondary_cat_val"
                                class="text-gray-400 text-base shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                                @change="onSecondaryCategoryChangefunc(index, $event)" v-model="sec_cat_vals[index]">
                                <option value="undefined">Category</option>
                                <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                              </select>
                              <div
                                class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                                <i class="fa fa-sort-desc" aria-hidden="true"></i>
                              </div>
                            </div>
                            <div class="relative focus:outline-none lg:w-52 w-40  inline-block">
                              <select id="sec_subcat_select" name="sec_subcat_select" autocomplete="sec_subcat_select"
                                class="text-gray-400 text-base shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                                v-model="secondary_subcats[index]">
                                <option value="undefined">Sub Category</option>
                                <option v-for="subcat_val in sec_subcat_vals[index]" :value="subcat_val.id">
                                  {{ subcat_val.name }}</option>
                              </select>
                              <div
                                class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                                <i class="fa fa-sort-desc" aria-hidden="true"></i>
                              </div>
                            </div>
                            <i v-if="index >= 0"
                              class="fa fa-minus-circle plus-font-size products-edit-minus-color cursor-pointer"
                              aria-hidden="true" @click="onSecondaryCatRemoveFieldRow(index)"></i>
                          </div>
                        </div>
                        <i class="fa fa-plus-circle plus-font-size products-edit-minus-color cursor-pointer"
                          aria-hidden="true" @click="onSecondaryCatAddFieldRow"></i>
                      </div>
                    </td>
                  </tr>
                  <!-- <tr class="bg-white" colspan="6">
                    <td colspan="6" class="px-6 pb-4 whitespace-nowrap text-base font-bold"></td>
                    <td class="md:pl-60 pl-44 pb-4 whitespace-nowrap text-base font-bold">

                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>



      <header
        class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg sm:mx-10 mx-6 mt-10">
        <h2 class="text-white text-lg font-bold w-11/12">Product Tags</h2>

      </header>

      <div class="flex flex-col mb-6 mx-10">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full">
                <thead class="header-bg-color">
                  <tr>
                    <th colspan="3" scope="col"
                      class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Create New Tag
                    </th>
                    <th colspan="5" scope="col"
                      class="px-14  py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      Current Tags
                    </th>


                  </tr>
                </thead>
                <tbody>
                  <!-- Oddd row -->
                  <tr class="bg-white">
                    <td colspan="3" class="px-6 py-4 whitespace-nowrap text-base font-bold space-x-4">


                      <input type="text" v-model="product_tags_add"
                        class="2xl:text-base text-base text-gray-400 xl:mt-0 mt-4 w-96 shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-xl select-menu-height input-background inline-block">

                      <i class="fa fa-plus-circle plus-font-size products-edit-minus-color inline-block"
                        aria-hidden="true" @click="onTagAdditionfunc"></i>







                    </td>


                    <td class="py-4 whitespace-nowrap text-base font-bold uppercase">

                      <div class="flex flex-wrap">
                        <div v-for="(product_tag, index) in form.product_tags_val" class="mb-4 mr-2">
                          <i class="current_tag fa fa-minus-circle plus-font-size products-edit-minus-color inline-block"
                            aria-hidden="true" @click="onTagRemovefunc(index)"></i>
                          <input type="text" :value="product_tag"
                            class="pl-10 uppercase 2xl:text-base text-base text-gray-400 xl:mt-0 mt-4 w-30 text-center shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-xl select-menu-height input-background inline-block">
                        </div>
                      </div>

                    </td>



                  </tr>





                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>




      <header
        class="mx-8 searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mt-8">
        <h2 class="text-white text-lg font-bold w-11/12">Case Information</h2>


      </header>
      <div class="mx-8 flex flex-col mb-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col"
                      class=" px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      case weight
                    </th>
                    <th scope="col"
                      class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      sub case weight
                    </th>
                    <th scope="col"
                      class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      case volume
                    </th>

                    <th scope="col"
                      class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      sub case volume
                    </th>



                    <th scope="col"
                      class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      case qty
                    </th>

                    <th scope="col"
                      class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      sub case qty
                    </th>

                    <th scope="col"
                      class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                      yield (%)
                    </th>


                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white">




                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">
                      <div class="flex">
                        <input type="number" min="0" step="1" id="case_weight" name="case_weight"
                          v-model="form.case_weight"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="case_mass_uom" name="case_mass_uom" autocomplete="case_mass_uom"
                            v-model="form.case_mass_uom"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-24 select-menu-height">
                            <option v-for="(mass_measurement, index) in mass_measurements" :value="mass_measurement.id">
                              {{ mass_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">
                      <div class="flex">
                        <input type="number" min="0" step="1" id="sub_case_weight" name="sub_case_weight"
                          v-model="form.sub_case_weight"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="subcase_mass_uom" name="subcase_mass_uom" autocomplete="subcase_mass_uom"
                            v-model="form.subcase_mass_uom"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-24 select-menu-height">
                            <option v-for="mass_measurement in mass_measurements" :value="mass_measurement.id">
                              {{ mass_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">
                      <div class="flex">
                        <input type="number" min="0" step="1" id="case_volume" name="case_volume"
                          v-model="form.case_volume"
                          class="shadow-sm focus:outline-none block w-14 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="case_vol_uom" name="case_vol_uom" autocomplete="case_vol_uom"
                            v-model="form.case_vol_uom"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-24 select-menu-height">
                            <option v-for="volume_measurement in volume_measurements" :value="volume_measurement.id">
                              {{ volume_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">
                      <div class="flex">
                        <input type="number" min="0" step="1" id="sub_case_volume" name="sub_case_volume"
                          v-model="form.sub_case_volume"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="case_vol_sub_uom" name="case_vol_sub_uom" autocomplete="case_vol_sub_uom"
                            v-model="form.case_vol_sub_uom"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-24 select-menu-height">
                            <option v-for="volume_measurement in volume_measurements" :value="volume_measurement.id">
                              {{ volume_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>


                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">

                      <input type="number" min="0" step="1" id="case_qty" name="case_qty" v-model="form.case_qty"
                        class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                    </td>

                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">

                      <input type="number" min="0" step="1" id="sub_case_qty" name="sub_case_qty" v-model="form.sub_case_qty"
                        class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                    </td>


                    <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center  justify-center">
                      <input type="number" min="0" max="100" placeholder="100" id="pyield" name="pyield"
                        v-model="form.pyield"
                        class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>






      <header
        class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mx-6 mt-8">
        <h2 class="text-white text-lg font-bold w-11/12">USDA Component Information (1 Serving) </h2>

      </header>

      <div class="flex flex-col mb-6 px-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      1 SERVING WEIGHT
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      1 SERVING VOLUME
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      1 SERVING UNIT
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      Source Code
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      <div class="flex">
                        <input type="text"
                          @input="convertToDecimal('serving_component_weight_fractions', 'serving_component_weight')"
                          name="mass_measurements" v-model="form.serving_component_weight_fractions" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 
                          text-center mr-2">
                        <input type="hidden" min="0" step="0.001" id="mass_measurements" name="mass_measurements"
                          v-model="form.serving_component_weight"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="serving_component_weight_type" name="serving_component_weight_type"
                            autocomplete="serving_component_weight_type" v-model="form.serving_component_weight_type"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <option v-for="mass_measurement in mass_measurements" :value="mass_measurement.id">
                              {{ mass_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </th>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                      <div class="flex">

                        <input type="text"
                          @input="convertToDecimal('serving_component_volume_fractions', 'serving_component_volume')"
                          v-model="form.serving_component_volume_fractions" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 
                          text-center mr-2">


                        <input type="hidden" min="0" step="0.001" id="serving_component_volume"
                          name="serving_component_volume" v-model="form.serving_component_volume"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select @change="servingVolumChange()" id="serving_component_volume_type"
                            name="serving_component_volume_type" autocomplete="serving_component_volume_type"
                            v-model="form.serving_component_volume_type"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <option v-for="volume_measurement in volume_measurements" :value="volume_measurement.id">
                              {{ volume_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>


                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                      <div class="flex">
                        <input type="text"
                          @input="convertToDecimal('serving_component_unit_fractions', 'serving_component_unit')"
                          v-model="form.serving_component_unit_fractions"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <input type="hidden" min="0" step="0.001" id="serving_component_unit"
                          name="serving_component_unit" v-model="form.serving_component_unit"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="serving_component_unit_measurement" name="serving_component_unit_measurement"
                            autocomplete="serving_component_unit_measurement"
                            v-model="form.serving_component_unit_measurement"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">

                            <option v-for="unit_measurement in unit_measurements" :value="unit_measurement.id">
                              {{ unit_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>


                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center">
                      <div class="flex">
                        <input type="text" id="usda_component_source_code" name="usda_component_source_code"
                          v-model="form.usda_component_source_code"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                      </div>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center flex justify-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="min-w-full shadow rounded-t-lg overflow-hidden table-background">
                <thead>
                  <tr class="">
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      meat <p class="lowercase">(oz eq)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      grain <p class="lowercase">(oz eq)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      fruit <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      milk <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      veg <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      veg/bpl <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      veg/red <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      veg/grn <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      veg/star <p class="lowercase">(cups)</p>
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      veg/othr <p class="lowercase">(cups)</p>
                    </th>



                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white">
                    <td scope="col"
                      class="px-3 py-2 text-center text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_meat"
                        name="usda_componenent_serving_meat" v-model="form.usda_componenent_serving_meat"
                        @blur="nearestValue('usda_componenent_serving_meat', true)"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_grain"
                        name="usda_componenent_serving_grain" v-model="form.usda_componenent_serving_grain"
                        @blur="nearestValue('usda_componenent_serving_grain', true)"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_fruit"
                        name="usda_componenent_serving_fruit" v-model="form.usda_componenent_serving_fruit"
                        @blur="nearestValue('usda_componenent_serving_fruit')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_milk"
                        name="usda_componenent_serving_milk" v-model="form.usda_componenent_serving_milk"
                        @blur="nearestValue('usda_componenent_serving_milk')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_veg"
                        name="usda_componenent_serving_veg" v-model="form.usda_componenent_serving_veg"
                        @blur="nearestValue('usda_componenent_serving_veg')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_vegleg"
                        name="usda_componenent_serving_vegleg" v-model="form.usda_componenent_serving_vegleg"
                        @blur="nearestValue('usda_componenent_serving_vegleg')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_vegred"
                        name="usda_componenent_serving_vegred" v-model="form.usda_componenent_serving_vegred"
                        @blur="nearestValue('usda_componenent_serving_vegred')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col" class="px-3 py-2 text-left text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_veggrn"
                        name="usda_componenent_serving_veggrn" v-model="form.usda_componenent_serving_veggrn"
                        @blur="nearestValue('usda_componenent_serving_veggrn')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col"
                      class="px-3 py-2 text-left text-sm font-white ttext-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_vegstar"
                        name="usda_componenent_serving_vegstar" v-model="form.usda_componenent_serving_vegstar"
                        @blur="nearestValue('usda_componenent_serving_vegstar')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>
                    <td scope="col"
                      class="px-3 py-2 text-left  text-sm font-white text-gray-400 uppercase tracking-wider">
                      <input type="number" min="0" step="0.001" id="usda_componenent_serving_vegothr"
                        name="usda_componenent_serving_vegothr" v-model="form.usda_componenent_serving_vegothr"
                        @blur="nearestValue('usda_componenent_serving_vegothr')"
                        class="shadow-sm focus:outline-none block w-20 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center">
                    </td>

                  </tr>
                </tbody>

              </table>

              <table class="min-w-full divide-y divide-gray-200"
                v-if="form.usda_componenent_serving_milk > 0 || form.usda_componenent_serving_veg > 0 || form.usda_componenent_serving_grain > 0 || form.usda_componenent_serving_fruit > 0">
                <thead class="bg-gray-50">
                  <tr>
                    <th v-if="form.usda_componenent_serving_milk > 0" scope="col"
                      class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      ADDITIONAL MILK INFO
                    </th>
                    <th v-if="form.usda_componenent_serving_veg > 0 || form.usda_componenent_serving_fruit > 0"
                      scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      IS THE PRODUCT JUICE
                    </th>
                    <th v-if="form.usda_componenent_serving_grain > 0" scope="col"
                      class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      WHOLE GRAINS INFO
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th v-if="form.usda_componenent_serving_milk > 0"
                      class="px-3 py-3 text-left text-sm font-bold text-gray-600 align-top">
                      <div class="flex">
                        <div class="relative focus:outline-none W-44 mr-2">
                          <select id="is_the_milk_flavored" name="is_the_milk_flavored"
                            autocomplete="is_the_milk_flavored" v-model="form.is_the_milk_flavored"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Is the Milk Flavored?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>

                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_the_milk_flavored" class="validation_error_msg">{{
                            form.errors.is_the_milk_flavored }}</div>
                        </div>


                        <div class="relative focus:outline-none W-44">
                          <select id="milk_fat_content" name="milk_fat_content" autocomplete="milk_fat_content"
                            v-model="form.milk_fat_content"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Milk Fat Content</option>
                            <option value="Whole Milk">Whole Milk</option>
                            <option value="Reduced Fat 2%">Reduced Fat 2%</option>
                            <option value="Low Fat 1%">Low Fat 1%</option>
                            <option value="Fat-Free / Skim">Fat-Free / Skim</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>

                          <div v-if="form.errors.milk_fat_content" class="validation_error_msg">{{
                            form.errors.milk_fat_content }}</div>
                        </div>

                      </div>
                    </th>
                    <td v-if="(form.usda_componenent_serving_veg > 0) || (form.usda_componenent_serving_fruit > 0)"
                      class="px-3 py-3 whitespace-nowrap text-sm text-gray-500  align-top">
                      <div class="flex">
                        <div class="relative focus:outline-none W-44 mr-2">
                          <select id="is_the_product_juice" name="is_the_product_juice"
                            autocomplete="is_the_product_juice" v-model="form.is_the_product_juice"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-40 select-menu-height">
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_the_product_juice" class="validation_error_msg">{{
                            form.errors.is_the_product_juice }}</div>
                        </div>

                        <!-- <div class="flex flex-col">
                        <input type="number" placeholder="%"  id="the_product_juice_value" name="the_product_juice_value"
                          v-model="form.the_product_juice_value"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center ">
                          <div v-if="form.errors.the_product_juice_value" class="validation_error_msg">{{ form.errors.the_product_juice_value }}</div>
                        </div>                      -->
                      </div>
                    </td>


                    <td v-if="form.usda_componenent_serving_grain > 0"
                      class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 align-top">
                      <div class="flex">
                        <div class="mr-2 relative focus:outline-none W-44">
                          <select id="is_whole_grains_info" name="is_whole_grains_info"
                            autocomplete="is_whole_grains_info" v-model="form.is_whole_grains_info"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Whole Grain Rich?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>

                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_whole_grains_info" class="validation_error_msg">{{
                            form.errors.is_whole_grains_info }}</div>
                        </div>
                        <div class="relative focus:outline-none W-44">
                          <select id="is_whole_grains_dessert" name="is_whole_grains_dessert"
                            autocomplete="is_whole_grains_dessert" v-model="form.is_whole_grains_dessert"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Is this a dessert?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_whole_grains_dessert" class="validation_error_msg">{{
                            form.errors.is_whole_grains_dessert }}</div>
                        </div>
                      </div>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center flex justify-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>






      <h3 class="searching-background-color py-2 rounded-md rounded-b-none text-white font-bold text-lg pl-6 mx-6">
        Nutrition Facts <span
          v-if="!(getGramId('Gram') == form.nutrition_mass_measurement && form.nutrition_facts_weight == 100) && form.nutrition_facts_weight > 0 && form.nutrition_mass_measurement != ''"
          @click="convert100GramType = 'Gram'; convert100Gram = true"
          class="menu1-background-color justify-center rounded-md font-bold px-4 py-1.5 button-color text-white focus:outline-none text-base ml-5 cursor-pointer">View
          as 100g</span>

        <span
          v-if="!(getMilligramId() == form.nutrition_vol_measurement && form.nutrition_facts_volume == 100) && form.nutrition_facts_volume > 0 && form.nutrition_vol_measurement != ''"
          @click="convert100GramType = 'Millilitre'; convert100Gram = true"
          class="menu1-background-color justify-center rounded-md font-bold px-4 py-1.5 button-color text-white focus:outline-none text-base ml-5 cursor-pointer">View
          as 100ml</span>


      </h3>
      <div class="flex flex-col mb-6 px-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      WEIGHT
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      VOLUME
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      UNIT
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      SOURCE CODE
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      <div class="flex">

                        <input type="text" v-model="form.nutrition_facts_weight_fractions"
                          @input="convertToDecimal('nutrition_facts_weight_fractions', 'nutrition_facts_weight')"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                        <input type="hidden" min="0" step="0.001" id="nutrition_facts_weight"
                          name="nutrition_facts_weight" v-model="form.nutrition_facts_weight"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                        <div class="relative focus:outline-none W-44">
                          <select id="nutrition_mass_measurement" name="nutrition_mass_measurement"
                            autocomplete="nutrition_mass_measurement" v-model="form.nutrition_mass_measurement"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <option v-for="mass_measurement in mass_measurements" :value="mass_measurement.id">
                              {{ mass_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </th>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                      <div class="flex">
                        <input type="text" v-model="form.nutrition_facts_volume_fractions"
                          @input="convertToDecimal('nutrition_facts_volume_fractions', 'nutrition_facts_volume')"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <input type="hidden" min="0" step="0.001" id="nutrition_facts_volume"
                          name="nutrition_facts_volume" v-model="form.nutrition_facts_volume"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="nutrition_vol_measurement" name="nutrition_vol_measurement"
                            autocomplete="nutrition_vol_measurement" v-model="form.nutrition_vol_measurement"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <option v-for="volume_measurement in volume_measurements" :value="volume_measurement.id">
                              {{ volume_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                      <div class="flex">
                        <input type="text" v-model="form.nutrition_facts_unit_fractions"
                          @input="convertToDecimal('nutrition_facts_unit_fractions', 'nutrition_facts_unit')"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                        <input type="hidden" min="0" step="0.001" id="nutrition_facts_unit" name="nutrition_facts_unit"
                          v-model="form.nutrition_facts_unit"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="nutrition_unit_measurement" name="nutrition_unit_measurement"
                            autocomplete="nutrition_unit_measurement" v-model="form.nutrition_unit_measurement"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <option v-for="unit_measurement in unit_measurements" :value="unit_measurement.id">
                              {{ unit_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center">
                      <div class="flex">
                        <input type="text" id="nutrition_facts_source_code" name="nutrition_facts_source_code"
                          v-model="form.nutrition_facts_source_code"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                      </div>
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center flex justify-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
              <!---------------even row-------->
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      calories
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      cal/fat
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      total fat
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      sat fat
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      trans fat
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      POLYUNSAT FAT
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      MONOUNSAT FAT
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      cholesterol
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      sodium
                    </th>
                  </tr>
                </thead>

                <tbody>

                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_calories"
                          name="nutrition_facts_calories" v-model="form.nutrition_facts_calories"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">cals</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_calfat"
                          name="nutrition_facts_calfat" v-model="form.nutrition_facts_calfat"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-gray-400">cals</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_totalfat"
                          name="nutrition_facts_totalfat" v-model="form.nutrition_facts_totalfat"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_satfat"
                          name="nutrition_facts_satfat" v-model="form.nutrition_facts_satfat"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_transfat"
                          name="nutrition_facts_transfat" v-model="form.nutrition_facts_transfat"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_polysatfat"
                          name="nutrition_facts_polysatfat" v-model="form.nutrition_facts_polysatfat"
                          class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_monosatfat"
                          name="nutrition_facts_monosatfat" v-model="form.nutrition_facts_monosatfat"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_cholesterol"
                          name="nutrition_facts_cholesterol" v-model="form.nutrition_facts_cholesterol"
                          class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class=" text-sm text-gray-400">mg</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_sodium"
                          name="nutrition_facts_sodium" v-model="form.nutrition_facts_sodium"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>

                    </th>
                  </tr>
                </tbody>




                <!-- Even row -->


                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      potassium
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      carbs
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      fiber
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Total Sugar
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      added sugars
                    </th>

                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      protein
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      vitamin a
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      vitamin b6
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      vitamin b12
                    </th>

                  </tr>
                </thead>

                <tbody>

                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_potassium"
                          name="nutrition_facts_potassium" v-model="form.nutrition_facts_potassium"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>



                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_carbs" name="nutrition_facts_carbs"
                          v-model="form.nutrition_facts_carbs"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-gray-400">g</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_fiber" name="nutrition_facts_fiber"
                          v-model="form.nutrition_facts_fiber"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">

                        <input type="number" min="0" step="0.001" id="nutrition_facts_sugar" name="nutrition_facts_sugar"
                          v-model="form.nutrition_facts_sugar"
                          class="hadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>

                      </div>
                    </th>

                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_added_sugars"
                          name="nutrition_facts_added_sugars" v-model="form.nutrition_facts_added_sugars"
                          class="hadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>
                    </th>

                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">

                        <input type="number" min="0" step="0.001" id="nutrition_facts_protein"
                          name="nutrition_facts_protein" v-model="form.nutrition_facts_protein"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">

                        <input type="number" min="0" step="0.001" id="nutrition_facts_vitamina"
                          name="nutrition_facts_vitamina" v-model="form.nutrition_facts_vitamina"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mcg RAE</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">

                        <input type="number" min="0" step="0.001" id="nutrition_facts_vitaminb6"
                          name="nutrition_facts_vitaminb6" v-model="form.nutrition_facts_vitaminb6"
                          class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class=" text-sm text-gray-400">mg</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">

                      <div class="flex items-center">

                        <input type="number" min="0" step="0.001" id="nutrition_facts_vitaminb12"
                          name="nutrition_facts_vitaminb12" v-model="form.nutrition_facts_vitaminb12"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mcg</p>
                      </div>

                    </th>

                  </tr>
                </tbody>




                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      vitamin c
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      vitamin d
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      vitamin e
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      calcium
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      iron
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      magnesium
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Cobalamin
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Thiamine
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Riboflavin
                    </th>

                  </tr>
                </thead>

                <tbody>

                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" id="nutrition_facts_vitaminc" name="nutrition_facts_vitaminc"
                          v-model="form.nutrition_facts_vitaminc"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">

                      <div class="flex items-center">
                        <input type="number" min="0" id="nutrition_facts_vitamind" name="nutrition_facts_vitamind"
                          v-model="form.nutrition_facts_vitamind"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mcg</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" min="0" id="nutrition_facts_vitamine" name="nutrition_facts_vitamine"
                          v-model="form.nutrition_facts_vitamine"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-gray-400">mg</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" id="nutrition_facts_calcium" name="nutrition_facts_calcium"
                          v-model="form.nutrition_facts_calcium"
                          class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_iron" name="nutrition_facts_iron"
                          v-model="form.nutrition_facts_iron"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_magnesium"
                          name="nutrition_facts_magnesium" v-model="form.nutrition_facts_magnesium"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_coblamin"
                          name="nutrition_facts_coblamin" v-model="form.nutrition_facts_coblamin"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" step="0.001" id="nutrition_facts_thiamin" name="nutrition_facts_thiamin"
                          v-model="form.nutrition_facts_thiamin"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class=" text-sm text-gray-400">mg</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_riboflavin"
                          name="nutrition_facts_riboflavin" v-model="form.nutrition_facts_riboflavin"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>


                    </th>

                  </tr>
                </tbody>







                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Niacin
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      zinc
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      water
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      ash
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">

                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">

                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">

                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">

                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">

                    </th>

                  </tr>
                </thead>

                <tbody>

                  <!-- Odd row -->
                  <tr class="bg-white">
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_niacin"
                          name="nutrition_facts_niacin" v-model="form.nutrition_facts_niacin"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>

                    </th>

                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" step="0.001" min="0" id="nutrition_facts_zinc" name="nutrition_facts_zinc"
                          v-model="form.nutrition_facts_zinc"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">mg</p>
                      </div>


                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600 ">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_water" name="nutrition_facts_water"
                          v-model="form.nutrition_facts_water"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-gray-400">g</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      <div class="flex items-center">
                        <input type="number" min="0" step="0.001" id="nutrition_facts_ash" name="nutrition_facts_ash"
                          v-model="form.nutrition_facts_ash"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <p class="text-sm text-gray-400">g</p>
                      </div>

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                      &nbsp;&nbsp;

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;



                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                      &nbsp;&nbsp;
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">

                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    </th>
                    <th class="px-3 py-3 text-left text-sm font-bold text-gray-600">


                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;

                    </th>

                  </tr>
                </tbody>
              </table>


            </div>
          </div>
        </div>
      </div>

      <h3 class="searching-background-color py-2 rounded-md rounded-b-none text-white font-bold text-lg px-4 mx-6">
        Allergens</h3>
      <div class="flex flex-col mb-6 px-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th v-for="allergen in allergens" scope="col"
                      class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      {{ allergen.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white">
                    <td v-for="allergen in allergens"
                      class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      <input type="checkbox" name="product_allergen_ids" :value="allergen.id"
                        v-model="form.product_allergen_ids"
                        class="w-5 h-5 appearance-none checked:bg-blue-600 rounded-sm bg-gray-100 border-gray-300 focus:ring-0 focus:ring-offset-0 cursor-pointer">
                    </td>
                  </tr>

                  <!-- Even row -->


                  <!-- More people... -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <header
        class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mx-6 mt-8">
        <h2 class="text-white text-lg font-bold w-11/12">Custom Unit of Measurements</h2>

      </header>

      <div class="flex flex-col mb-6 px-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Base Weight
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Conversion
                    </th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      Name
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      <i @click="addCustomUnit()"
                        class="fa fa-plus-circle plus-font-size products-edit-minus-color cursor-pointer"
                        aria-hidden="true"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white"
                    v-for="(custom_units_of_measurement, index ) in  form.custom_units_of_measurements">
                    <td class="px-3 py-3 text-left text-sm font-bold text-gray-600 uppercase">
                      <div class="flex">

                        <input type="text" v-model="form.custom_units_of_measurements[index].weight_fractions"
                          @input="customConvertToDecimal(index, 'weight_fractions', 'weight')" name="mass_measurements"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                        <input type="hidden" min="0" step="0.001"
                          v-model="form.custom_units_of_measurements[index].weight"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">
                          <select id="serving_component_weight_type" name="serving_component_weight_type"
                            autocomplete="serving_component_weight_type"
                            v-model="form.custom_units_of_measurements[index].weight_units"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <option v-for="mass_measurement in mass_measurements" :value="mass_measurement.name">
                              {{ mass_measurement.name }}</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                      =
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                      <div class="flex">
                        <input type="text" v-model="form.custom_units_of_measurements[index].unit_amount_fractions"
                          @input="customConvertToDecimal(index, 'unit_amount_fractions', 'unit_amount')"
                          name="mass_measurements"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">


                        <input type="hidden" min="0" step="0.001" id="serving_component_volume"
                          name="serving_component_volume" v-model="form.custom_units_of_measurements[index].unit_amount"
                          class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                        <div class="relative focus:outline-none W-44">

                          <select id="serving_component_volume_type" name="serving_component_volume_type"
                            autocomplete="serving_component_volume_type"
                            v-model="form.custom_units_of_measurements[index].unit_type"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-28 select-menu-height">
                            <optgroup label="Weight">
                              <option v-for="mass_measurement in mass_measurements" :value="mass_measurement.name">
                                {{ mass_measurement.name }}</option>
                            </optgroup>
                            <optgroup label="Volume">
                              <option v-for="volume_measurement in volume_measurements" :value="volume_measurement.name">
                                {{ volume_measurement.name }}</option>
                            </optgroup>
                            <optgroup label="Unit">
                              <option v-for="unit_measurement in unit_measurements" :value="unit_measurement.name">
                                {{ unit_measurement.name }}</option>
                            </optgroup>
                            <optgroup label="Other">
                              <option value="Units">Unit</option>
                            </optgroup>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center">

                      <input maxlength="150" type="text" name=""
                        v-model="form.custom_units_of_measurements[index].description"
                        class="shadow-sm focus:outline-none block  p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2" />
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center flex justify-center">

                      <i class="fa fa-minus-circle plus-font-size products-edit-minus-color cursor-pointer"
                        v-if="form.custom_units_of_measurements.length > 1" aria-hidden="true"
                        @click="removeCustomUnit(index)"></i>
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      <!-- Distrbuter -->
      <header
        class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mx-6 mt-8">
        <h2 class="text-white text-lg font-bold w-11/12">Distributors</h2>

        <a href="javascript:void(0)" @click="openDistributorPopup()" class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-3" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
        </a>

      </header>

      <div class="flex flex-col mb-6 px-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
             <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          ACTIONS
                      </th>
                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          Distributor Name
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          DISTRIBUTOR NUMBER
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          UPC
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          CASE COST ($)
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          CASE WEIGHT	
                      </th>
                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          CASE WEIGHT UOM
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          SUB CASE WEIGHT	
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          SUB CASE WEIGHT	UOM
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          CASE VOLUME	
                      </th>
                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          CASE VOLUME UOM
                      </th>

                      

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          SUB CASE VOLUME	
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          SUB CASE VOLUME	UOM
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          CASE QTY	
                      </th>

                      <th
                          scope="col"
                          class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                      >
                          SUB CASE QTY
                      </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr class="bg-white"
                    v-for="distri in  form.distributor_products">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 flex items-center gap-1">

                      <CaseInfo :distributorInfo="distri" />
                      <i class="fa fa-trash cursor-pointer text-red-600  h-8 w-6 !text-xl" aria-hidden="true" @click="removeDistributor(distri.id)"></i>
                       <svg v-if="distri.distributor.id == form.distributor_id_val" xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-6 cart-color" viewBox="0 0 20 20" fill="currentColor">
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>

                      <svg v-else @click="form.distributor_id_val = distri.distributor.id" xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-6 cart-color cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>

                    </td>

                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.distributor.name }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.item_number }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.upc }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.case_cost }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.case_weight }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.case_weight_uom }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.sub_case_weight }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.sub_case_weight_uom }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.case_volume }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.case_volume_uom }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.sub_case_volume }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.sub_case_volume_uom }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.case_qty }} 
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{ distri.sub_case_qty }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- End Distributor -->

      <div class="w-full flex lg:flex-nowrap flex-wrap md:justify-end items-center pr-6 pb-6 md:ml-0 ml-6">
        <button type="button">
          <inertia-link :href="route('products')"
            class="w-full inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-gray-500 text-white  focus:outline-none sm:w-40">Cancel</inertia-link>
        </button>
        <button type="button" @click="product_add_save_script"
          class="menu1-background-color w-full inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase button-color text-white  focus:outline-none sm:ml-3 sm:w-40 mt-3 sm:mt-0">
          Save
        </button>





      </div>

    </form>

    <jet-dialog-modal :show="addProductsModalWarring" @close="addProductsModalWarring = false">
      <template #title>
        <div class="flex justify-between items-center text-red-600 text-xl font-bold">
          Warning
        </div>
      </template>

      <template #content>
        <p>You are attempting to add a product that does not have USDA component information. In order to proceed, please
          add the values and try again or proceed by setting all values to zero.</p>

      </template>

      <template #footer>
        <div class="flex justify-end items-center">
          <button @click="addProductsModalWarring = false"
            class="inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest shadow-sm focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200 active:text-gray-800 active:bg-gray-50 disabled:opacity-25 transition bg-gray-500 text-white inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase text-base mr-2">Cancel</button>
          <button @click="setComponentZero"
            class="inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase bg-red-500 text-white text-base">Set
            all component values to zero </button>

        </div>
      </template>
    </jet-dialog-modal>


    <jet-dialog-modal :show="showCnPopup" @close="hideCNNutrations" :closeable="false">
      <template #title>
        <div class="flex justify-between items-center  text-xl font-bold">
          We found a match : {{ cnProduct?.name }}
        </div>
      </template>

      <template #content>
        <p>Would you like us to import the nutrition information?</p>

      </template>

      <template #footer>
        <div class="flex justify-end items-center">
          <button @click="hideCNNutrations"
            class="inline-flex items-center   border border-gray-300 tracking-widest shadow-sm focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200 active:text-gray-800 active:bg-gray-50 disabled:opacity-25 transition bg-gray-500 text-white  justify-center rounded-md font-bold px-4 py-3.5 uppercase text-base mr-2">No</button>
          <button @click="importCNNutrations"
            class="inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase bg-red-500 text-white text-base">Yes</button>
        </div>
      </template>
    </jet-dialog-modal>

    <attach-distributor v-if="showDistributorPopup" @close="showDistributorPopup = false"
      :all_distributors="filteredDistributors" :product="product"  @attach-distributor-item="addDistributorItem">
    </attach-distributor>

    <ViewInGram @closePopUp="convert100Gram = false" v-if="convert100Gram" :mass_measurements="mass_measurements"
      :form="form" :convert100GramType="convert100GramType" :volume_measurements="volume_measurements" />

  </default-layout>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import JetDialogModal from '@/Jetstream/DialogModal';
import ViewInGram from '@/Pages/Products/ViewInGram';
import AttachDistributor from '@/Pages/Products/Popup/AttachDistributor';

export default {
  props: ['allergens', 'categories', 'distributors', 'menu_users', 'mass_measurements', 'unit_measurements', 'volume_measurements'],
  components: {
    DefaultLayout,
    Welcome,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    JetDialogModal,
    ViewInGram,
    AttachDistributor
  },
  data() {
    return {
      all_distributors: this.distributors,
      showDistributorPopup: false,
      convert100Gram: false,
      onvert100GramType: '',
      subcat_vals: [],
      sec_cat_counters: [1],
      sec_cat_length: 1,
      sec_cat_vals: [],
      sec_subcat_vals: [],
      secondary_subcats: [],
      addProductsModalWarring: false,
      showCnPopup: false,
      cnProduct: null,


      product_tags_add: '',

      form: this.$inertia.form({
        distributor_products: [],
        wbscm_commodity_code: null,
        custom_units_of_measurements: [
          {
            weight: null,
            weight_units: null,
            unit_amount: null,
            unit_type: null,
            description: null,
            weight_fractions: null,
            unit_amount_fractions: null,
          }
        ],
        serving_component_weight: '',

        serving_component_weight_type: '',
        serving_component_volume: '',
        serving_component_volume_type: '',
        serving_component_unit: '',


        serving_component_weight_fractions: '',
        serving_component_volume_fractions: '',
        serving_component_unit_fractions: '',

        nutrition_facts_weight_fractions: '',
        nutrition_facts_volume_fractions: '',
        nutrition_facts_unit_fractions: '',

        serving_component_unit_measurement: this.unit_measurements[0]['id'],

        is_the_milk_flavored: '',
        milk_fat_content: '',
        is_the_product_juice: '',
        // the_product_juice_value:'',
        is_whole_grains_dessert: '',
        is_whole_grains_info: '',

        pname: '',
        pmanufacturer: '',
        pmanufacturer_sku: '',
        cn_code: '',
        pgtin: '',
        pyield: '',
        distributor_id_val: '',
        primary_cat_val: '',
        primary_subcat_val: '',
        case_weight: '',
        sub_case_weight: '',
        sub_case_weight_uom: '',
        case_volume: '',
        sub_case_volume: '',
        sub_case_volume_uom: '',
        case_qty: '',
        sub_case_qty: '',
        mass_measurements: '',
        volume_measurement: '',
        unit_measurement: '',
        case_mass_uom: this.mass_measurements[0]['id'],
        subcase_mass_uom: this.mass_measurements[0]['id'],
        case_vol_uom: this.volume_measurements[0]['id'],
        case_vol_sub_uom: this.volume_measurements[0]['id'],
        mass_measurements_uom: this.mass_measurements[0]['id'],
        volume_measurement_uom: this.volume_measurements[0]['id'],
        unit_measurement_uom: this.unit_measurements[0]['id'],
        usda_componenent_serving_meat: '',
        usda_componenent_serving_grain: '',
        usda_componenent_serving_fruit: '',
        usda_componenent_serving_milk: '',
        usda_componenent_serving_veg: '',
        usda_componenent_serving_vegleg: '',
        usda_componenent_serving_vegred: '',
        usda_componenent_serving_veggrn: '',
        usda_componenent_serving_vegstar: '',
        usda_componenent_serving_vegothr: '',
        nutrition_facts_weight: '',
        nutrition_facts_volume: '',
        nutrition_facts_unit: '',
        nutrition_mass_measurement: this.mass_measurements[0]['id'],
        nutrition_vol_measurement: this.volume_measurements[0]['id'],
        nutrition_unit_measurement: this.unit_measurements[0]['id'],
        nutrition_facts_calories: '',
        nutrition_facts_calfat: '',
        nutrition_facts_totalfat: '',
        nutrition_facts_satfat: '',
        nutrition_facts_transfat: '',
        nutrition_facts_polysatfat: '',
        nutrition_facts_monosatfat: '',
        nutrition_facts_cholesterol: '',
        nutrition_facts_sodium: '',
        nutrition_facts_potassium: '',
        nutrition_facts_carbs: '',
        nutrition_facts_fiber: '',
        nutrition_facts_sugar: '',
        nutrition_facts_protein: '',
        nutrition_facts_vitamina: '',
        nutrition_facts_vitaminb6: '',
        nutrition_facts_vitaminb12: '',
        nutrition_facts_vitaminc: '',
        nutrition_facts_vitamind: '',
        nutrition_facts_vitamine: '',
        nutrition_facts_calcium: '',
        nutrition_facts_iron: '',
        nutrition_facts_magnesium: '',
        nutrition_facts_coblamin: '',
        nutrition_facts_thiamin: '',
        nutrition_facts_riboflavin: '',
        nutrition_facts_niacin: '',
        nutrition_facts_zinc: '',
        nutrition_facts_water: '',
        nutrition_facts_ash: '',

        nutrition_facts_added_sugars: '',
        nutrition_facts_source_code: '',

        usda_component_source_code: '',

        product_allergen_ids: [],
        product_tags_val: [],
        secondary_subcat_ids: [],
        filteredDistributors: [],

        // ,
        // user_id:''
      })
    }
  },
  methods: {

    nearestValue(cols, oneFourth) {
      this.form[cols] = this.$helpers.nearestValue(this.form[cols], oneFourth);
    },

    convertToDecimal(fractions, toField) {
      const fraction = this.form[fractions].trim();

      console.log("fraction", fraction);
      if (fraction == '') {
        this.form[toField] = null;
        return null;
      }

      // Regular expression to handle whole numbers, fractions like 1/2, and mixed numbers like 3 1/2
      const regex = /^(\d+)?\s*(\d+)?\/?(\d+)?$/;
      const match = fraction.match(regex);

      console.log("fraction oe ", fraction, match);

      if (match) {
        const wholeNumber = parseFloat(match[1]) || 0;
        const numerator = parseFloat(match[2]) || 0;
        const denominator = parseFloat(match[3]) || 1; // Avoid division by zero

        // Calculate the decimal value
        // console.log("fraction in ", wholeNumber + (numerator / denominator));
        if (numerator > 0) {
          this.form[toField] = wholeNumber + (numerator / denominator);
        } else {
          this.form[toField] = wholeNumber / denominator;
        }
        // this.form[toField] = wholeNumber + (numerator / denominator);
      } else {
        this.form[toField] = fraction; // Clear decimal field if the input is invalid
      }

      console.log("last fraction", fraction, this.form[toField]);
    },

    customConvertToDecimal(index, fractions, toField) {
      const fraction = this.form.custom_units_of_measurements[index][fractions].trim();

      console.log("fraction", fraction);

      // Regular expression to handle whole numbers, fractions like 1/2, and mixed numbers like 3 1/2
      const regex = /^(\d+)?\s*(\d+)?\/?(\d+)?$/;
      const match = fraction.match(regex);

      // console.log("match fraction ");

      if (match) {
        const wholeNumber = parseFloat(match[1]) || 0;
        const numerator = parseFloat(match[2]) || 0;
        const denominator = parseFloat(match[3]) || 1; // Avoid division by zero

        // Calculate the decimal value
        if (numerator > 0) {
          this.form.custom_units_of_measurements[index][toField] = wholeNumber + (numerator / denominator);
        } else {
          this.form.custom_units_of_measurements[index][toField] = wholeNumber / denominator;
        }
        // this.form.custom_units_of_measurements[index][toField] = wholeNumber + (numerator / denominator);
      } else {
        this.form.custom_units_of_measurements[index][toField] = ''; // Clear decimal field if the input is invalid
        this.form.custom_units_of_measurements[index][toField] = fraction;
      }
    },

    getGramId(type) {
      const item = this.mass_measurements.find(item => item.name === type);
      return item ? item.id : null;
    },
    getMilligramId() {
      const item = this.volume_measurements.find(item => item.name === 'Millilitre');
      return item ? item.id : null;
    },

    getMilligramId() {
      const item = this.volume_measurements.find(item => item.name === 'Millilitre');
      return item ? item.id : null;
    },

    addCustomUnit() {
      this.form.custom_units_of_measurements.push({
        weight: null,
        weight_units: null,
        unit_amount: null,
        unit_type: null,
        description: null,
        weight_fractions: null,
        unit_amount_fractions: null,
      });
      console.log("addCustomUnit", this.form.custom_units_of_measurements);
    },
    removeCustomUnit(index) {
      if (index > -1) {
        this.form.custom_units_of_measurements.splice(index, 1);
      }
      return false;
    },

    onCategoryChangefunc() {
      axios.post('/get_prod_subcategories', { category_id: this.form.primary_cat_val })
        .then((response) => {
          this.subcat_vals = [];
          this.subcat_vals = response.data;
        })
        .catch(error => console.error(error));
    },


    onSecondaryCategoryChangefunc(index, e) {
      axios.post('/get_prod_subcategories', { category_id: e.target.value })
        .then((response) => {
          this.sec_cat_vals[index] = e.target.value;
          this.sec_subcat_vals[index] = response.data;
        })
        .catch(error => console.error(error));
    },



    onTagAdditionfunc() {
      var tag_val = this.product_tags_add;
      if (tag_val != "") {
        this.form.product_tags_val.push(tag_val);
        this.product_tags_add = "";
      } else {
        this.$toast.error("Tag Value Can't Be Empty!");
      }
      return false;
    },


    onTagRemovefunc(index) {
      //var index = this.product_tags_val.indexOf(val);
      if (index > -1) {
        this.form.product_tags_val.splice(index, 1);
      }
      return false;
    },


    onSecondaryCatAddFieldRow() {
      this.sec_cat_length = this.sec_cat_counters.length;
      if (this.sec_cat_length < 5) {
        this.sec_cat_counters.push(1);
      } else {
        this.$toast.warning('Maximum 5 secondary categories allowed!');
      }
    },

    onSecondaryCatRemoveFieldRow(index) {
      this.sec_cat_counters.splice(index, 1);
      this.sec_cat_length = this.sec_cat_counters.length;
      this.sec_cat_vals.splice(index, 1);
      this.sec_subcat_vals.splice(index, 1);
      this.secondary_subcats.splice(index, 1);
    },

    setComponentZero() {
      this.form.usda_componenent_serving_meat = 0;
      this.form.usda_componenent_serving_grain = 0;
      this.form.usda_componenent_serving_fruit = 0;
      this.form.usda_componenent_serving_milk = 0;
      this.form.usda_componenent_serving_veg = 0;
      this.form.usda_componenent_serving_vegleg = 0;
      this.form.usda_componenent_serving_vegred = 0;
      this.form.usda_componenent_serving_veggrn = 0;
      this.form.usda_componenent_serving_vegstar = 0;
      this.form.usda_componenent_serving_vegothr = 0;
      this.addProductsModalWarring = false;
      this.product_add_save_script();
    },

    product_add_save_script() {
      if (
        this.form.usda_componenent_serving_meat === ''
        && this.form.usda_componenent_serving_grain === ''
        && this.form.usda_componenent_serving_fruit === ''
        && this.form.usda_componenent_serving_milk === ''
        && this.form.usda_componenent_serving_veg === ''
        && this.form.usda_componenent_serving_vegleg === ''
        && this.form.usda_componenent_serving_vegred === ''
        && this.form.usda_componenent_serving_veggrn === ''
        && this.form.usda_componenent_serving_vegstar === ''
        && this.form.usda_componenent_serving_vegothr === ''
      ) {
        this.addProductsModalWarring = true;
        console.log("product_add_save_script false", this.form.usda_componenent_serving_meat);
      } else {
        this.form.secondary_subcat_ids = this.secondary_subcats;
        this.form.post(this.route('products_add_save'), {
          onSuccess: () => {
            this.$toast.success('Product Added Successfully!');
          },
        });
      }
    },

    servingVolumChange() {
      console.log('nutrition_facts_volume', this.form.nutrition_facts_volume);
      this.form.nutrition_vol_measurement = this.form.serving_component_volume_type;
      //   this.form.nutrition_facts_volume = null;
    },
    getCNNutrations() {
      console.log('this.form.cn_code', this.form.cn_code);
      if (this.form.cn_code && this.cnProduct == null) {
        axios.post('/get-cn-nutritions', { cn_code: this.form.cn_code })
          .then((response) => {
            // console.log('response', response.data);
            if (response.data.status) {
              this.cnProduct = response.data.data;
              this.showCnPopup = true;
            }
          })
          .catch(error => console.error(error));
      }
    },
    hideCNNutrations() {
      this.cnProduct = null;
      this.showCnPopup = false;
    },
    importCNNutrations() {
      if (this.cnProduct) {
        Object.keys(this.cnProduct).forEach((key) => {
          if (key.startsWith('nutrition_facts_') && this.form.hasOwnProperty(key)) {
            this.form[key] = this.cnProduct[key];
          }
          if (key.startsWith('usda_componenent_') && this.form.hasOwnProperty(key)) {
            this.form[key] = this.cnProduct[key];
          }

          if (key.startsWith('serving_component_') && this.form.hasOwnProperty(key)) {
            this.form[key] = this.cnProduct[key];
          }
        });

        if (this.cnProduct.custom_units_of_measurements.length > 0) {
          this.form.custom_units_of_measurements = [];
          for (let i = 0; i < this.cnProduct.custom_units_of_measurements.length; i++) {
            this.form.custom_units_of_measurements.push({
              is_usda: this.cnProduct.custom_units_of_measurements[i].is_usda,
              weight: this.cnProduct.custom_units_of_measurements[i].weight,
              weight_units: this.cnProduct.custom_units_of_measurements[i].weight_units,
              unit_amount: this.cnProduct.custom_units_of_measurements[i].unit_amount,
              unit_type: this.cnProduct.custom_units_of_measurements[i].unit_type,
              description: this.cnProduct.custom_units_of_measurements[i].description,
              weight_fractions: this.cnProduct.custom_units_of_measurements[i].weight_fractions,
              unit_amount_fractions: this.cnProduct.custom_units_of_measurements[i].unit_amount_fractions
            });
          }
        }
      }
      this.hideCNNutrations();
      // this.showCnPopup = false;
    },
    addDistributorItem(distributor_product) {
      this.form.distributor_products.push(distributor_product);
    },
    removeDistributor(id) {
      if(confirm('Are you sure you want to remove this distributor?')) {
          console.log("this.form.distributor_products", this.form.distributor_products);
          this.form.distributor_products = this.form.distributor_products.filter(item => item.id !== id);
            console.log("this.form.distributor_products end ", this.form.distributor_products);
      }

    },
    openDistributorPopup(){
      this.showDistributorPopup = true;
      this.filteredDistributors = this.getFilteredDistributors();
    },

    getFilteredDistributors() {
        const existingDistributorIds = (this.form.distributor_products || []).map(function(item) {
            return item.distributor_id;
        });
        return this.all_distributors.filter(distributor =>
            !existingDistributorIds.includes(distributor.id)
        );
    }
  },
};
</script>
<style>
.min-height-third {
  min-height: 400px;
}

.sm\:text-sm {
  font-size: 0.850rem;
  line-height: 1.25rem;
}

.w-52-rec {
  width: 13.2rem;
}

.input-background {
  background-color: #f8f8f8;
}

.text-base-heading {
  font-size: 14px;
}

.button-bg-color-wed-menu2-gray {
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.menu1-background-color {
  background-color: #FAA43D;
}

.products-edit-minus-color {
  color: #f7a53a;
}

.button-bg-color-wed-menu2 {
  background-color: #38558e;
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.menu1-icon-color {
  color: #38558e;
}

.id-color-menu-edit {
  color: #F7A53A;
}

.bg-button-color {
  background-color: #cb0000;
}

.min-w-min-button {
  min-height: 26px;
  min-width: 53px;

}

.w-150 {
  width: 150px;
}

.max-w-0-menu1 {
  max-width: 4rem;
}

.bg-button-color-green {
  background-color: #22af4b;
}

.plus-font-size {
  font-size: 20px;
}

.bg-button-color-gray {
  background-color: #636363;
}

.bg-hard-grey {
  background-color: #f4f4f4;
}

.font-size-edit {
  font-size: 10.5px;
}

.w-96-edit-recipes {
  width: 35rem;
}

.select-menu-height-edit2 {
  height: 2.8rem;
}

.pl-60-plus-icon {
  padding-left: 14.50rem;
}

.current_tag.fa-minus-circle:before {
  content: "\f056";
  position: relative;
  top: 1px;
  left: 30px;
}

.validation_error_msg {
  font-weight: 400;
  margin: 6px 0 0 !important;
  color: red;
}
</style>
